import styled from "styled-components";

const ButtonBase = styled.button`
	position: relative;
	display: flex;
	flex-direction: row;
	width: auto;
	height: 40px;
	padding-left: ${(props) => (props.hasIcon ? "16px" : "24px")};
	padding-right: 24px;
	gap: 8px;
	border-radius: 20px;
	justify-content: center;
	align-items: center;
	color: ${(props) => props.color};
	font-style: var(--md-sys-typescale-label-large-font-family-style);
	font-weight: var(--md-sys-typescale-label-large-font-weight);
	font-size: var(--md-sys-typescale-label-large-font-size);
	letter-spacing: var(--md-sys-typescale-label-large-tracking);
	line-height: var(--md-sys-typescale-label-large-height);
	text-transform: var(--md-sys-typescale-label-large-text-transform);
	text-decoration: var(--md-sys-typescale-label-large-text-decoration);
	cursor: pointer;
	opacity: ${(props) => (props.isDisabled ? "0.5" : "1")};
	pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
	transition: 0.3s;

	&:hover {
		opacity: 0.8;
	}
`;

const FilledButtonContent = styled(ButtonBase)`
	border: none;
	background: ${(props) => props.background};
`;

const OutlineButtonContent = styled(ButtonBase)`
	border: 2px solid ${(props) => props.color};
	background: ${(props) =>
		props.selected
			? `rgba(from ${props.color} r g b / 10%)`
			: "transparent"};

	&:hover {
		background: rgba(from ${(props) => props.color} r g b / 10%);
	}
`;

const TextButtonContent = styled(ButtonBase)`
	border: none;
	background: transparent;

	&:hover {
		background: rgba(from ${(props) => props.color} r g b / 10%);
	}
`;

const Icon = styled.div`
	width: 18px;
	height: 18px;
	color: ${(props) => props.color};

	span {
		width: 18px;
		height: 18px;
		font-size: 18px;
		line-height: 18px;
	}
`;

export function FilledButton({
	text,
	background = "var(--color-primary)",
	color = "var(--color-on-primary)",
	theme = "primary",
	type,
	onClick = () => { },
	isDisabled = false,
	children,
}) {
	switch (theme) {
		case "secondary":
			background = "var(--color-secondary)";
			color = "var(--color-on-secondary)";
			break;

		case "tertiary":
			background = "var(--color-tertiary)";
			children = "var(--color-on-tertiary)";
			break;
		case "error":
			background = "var(--color-error)";
			color = "var(--color-on-error)";
			break;
		case "custom":
			break;

		default:
			background = "var(--color-primary)";
			color = "var(--color-on-primary)";
			break;
	}

	return (
		<FilledButtonContent
			background={background}
			color={color}
			type={type}
			onClick={onClick}
			isDisabled={isDisabled}
		>
			{children && <Icon>{children}</Icon>}
			{text}
		</FilledButtonContent>
	);
}

export function OutlinedButton({
	text,
	color = "var(--color-primary)",
	theme = "primary",
	type,
	selected = false,
	onClick = () => { },
	isDisabled = false,
	children,
}) {
	switch (theme) {
		case "secondary":
			color = "var(--color-secondary)";
			break;

		case "tertiary":
			children = "var(--color-tertiary)";
			break;
		case "error":
			color = "var(--color-error)";
			break;
		case "custom":
			break;

		default:
			color = "var(--color-primary)";
			break;
	}

	return (
		<OutlineButtonContent
			color={color}
			type={type}
			onClick={onClick}
			selected={selected}
			isDisabled={isDisabled}
		>
			{children && <Icon>{children}</Icon>}
			{text}
		</OutlineButtonContent>
	);
}

export function TextButton({
	text,
	color = "var(--color-primary)",
	theme = "primary",
	type,
	onClick = () => { },
	isDisabled = false,
	children,
}) {
	switch (theme) {
		case "secondary":
			color = "var(--color-secondary)";
			break;

		case "tertiary":
			children = "var(--color-tertiary)";
			break;
		case "error":
			color = "var(--color-error)";
			break;
		case "custom":
			break;

		default:
			color = "var(--color-primary)";
			break;
	}

	return (
		<TextButtonContent
			color={color}
			type={type}
			onClick={onClick}
			isDisabled={isDisabled}
		>
			{children && <Icon>{children}</Icon>}
			{text}
		</TextButtonContent>
	);
}
